"use client";

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "next/navigation";

import { PasswordFormView } from "./PasswordFormView";
import { PasswordSuccessView } from "./PasswordSuccessView";

import { useApiWithLayout } from "@/hooks/api";
import { useToast } from "@/hooks/ui/useToast";

import { buildPasswordValidationRules } from "@/utils/validators/password-validation";

import postNewPasswordHandler from "@api/postNewPassword";

import { PostNewPasswordPayload } from "@api/postNewPassword/types";
import { ResetPasswordProps } from "./types";
import { removeAuthCookie } from "@/services/CookiesService";

export const ResetPassword = ({ resetPasswordData }: ResetPasswordProps) => {
  const searchParams = useSearchParams();
  const { t } = useTranslation("generic-errors");
  const { toast } = useToast();
  const token = searchParams.get("token");

  const {
    request,
    data: newPasswordResponseData,
    error,
    loading,
  } = useApiWithLayout(postNewPasswordHandler.postNewPassword);

  const [password, setPassword] = useState("");
  const [successSubmit, setSuccessSubmit] = useState(null);

  const validationRules = buildPasswordValidationRules(resetPasswordData, password);

  const onResetSubmit = (values: any, _methods: any) => {
    const payload: PostNewPasswordPayload = {
      token: token as string,
      password: values.password,
      passwordConfirm: values.repeatPassword,
    };
    request(payload);
  };

  useEffect(() => {
    if (newPasswordResponseData?.status === 201 || newPasswordResponseData?.status === 200) {
      setSuccessSubmit(true);
      removeAuthCookie();
    }
  }, [newPasswordResponseData]);

  useEffect(() => {
    if (error) {
      toast({ message: t("generic_error"), type: "error" });
    }
  }, [error]);

  return (
    <div
      className="recover-password"
      data-testid="Reset-password"
    >
      {successSubmit === null && (
        <PasswordFormView
          title={resetPasswordData.title}
          formFields={resetPasswordData.formFields}
          onSubmit={onResetSubmit}
          schema={validationRules}
          isLoading={loading}
          onWatchFields={({ field, value }) => {
            if (field === "password") setPassword(value);
          }}
        />
      )}

      {successSubmit && (
        <PasswordSuccessView
          successTitle={resetPasswordData.successTitle}
          successSubtitle={resetPasswordData.successSubtitle}
          successSubtitle_2={resetPasswordData.successSubtitle_2}
          acceptButton={resetPasswordData.acceptButton}
        />
      )}
    </div>
  );
};
